export default __webpack_public_path__ + "static/media/Ubuntu-MI.8b938dec.woff";